export class AccessDenied extends Error {
  constructor(url) {
    super(url)
    this.logingUrl = url
    this.name = this.constructor.name
  }
}
